import { OvTableData } from '../../../components/UI/molecules/OvTable';
import { Constants } from '../../constants';
import { DailyData } from '../../model/dto/daily-data';
import { TableRowEditWidgetType } from '../../model/ui/table-row-edit-widget.type';
import { JournalEntryFields } from '../../../firebase/document-field.enums';
import i18n from 'i18next';
import { JournalEntry } from '../../model/dto/journal-entry/journal-entry';
import { OverviewGroup } from '../../model/ui/overview-group';
import { SpikeInfo } from '../../model/dto/spike-info';

export class DailyDataUtils {
  static mapDailyDataToTable(dailyData: DailyData): OvTableData {
    const tableRows: OvTableData = [];
    const journalEntry = dailyData?.journal_entry;
    const spikeInfo = dailyData?.spike_info;

    if (dailyData?.displayLh?.value) {
      tableRows.push({
        label: 'common.dailyData.lh',
        translateLabel: true,
        value: dailyData.displayLh.value,
      });
    }

    if (dailyData?.displayPg?.value) {
      tableRows.push({
        label: 'common.dailyData.pg',
        translateLabel: true,
        value: dailyData.displayPg.value,
      });
    }

    if (dailyData?.displayLrE3g?.value) {
      tableRows.push({
        label: 'common.dailyData.e3g',
        translateLabel: true,
        value: dailyData.displayLrE3g.value,
      });
    }

    if (dailyData?.bleeding) {
      tableRows.push({
        label: 'common.dailyData.bleeding',
        translateLabel: true,
        value: dailyData?.bleeding,
      });
    }

    if (journalEntry?.hot_flashes) {
      tableRows.push({
        label: 'common.dailyData.hotFlashes',
        translateLabel: true,
        value: journalEntry?.hot_flashes,
      });
    }

    if (journalEntry?.breast_tenderness) {
      tableRows.push({
        label: 'common.dailyData.breastTenderness',
        translateLabel: true,
        value: journalEntry?.breast_tenderness,
      });
    }

    if (journalEntry?.cramps) {
      tableRows.push({
        label: 'common.dailyData.cramps',
        translateLabel: true,
        value: journalEntry?.cramps,
      });
    }

    if (journalEntry?.nausea) {
      tableRows.push({
        label: 'common.dailyData.nausea',
        translateLabel: true,
        value: journalEntry?.nausea,
      });
    }

    if (journalEntry?.joint_pain) {
      tableRows.push({
        label: 'common.dailyData.jointPain',
        translateLabel: true,
        value: journalEntry?.joint_pain,
      });
    }

    if (journalEntry?.back_pain) {
      tableRows.push({
        label: 'common.dailyData.backPain',
        translateLabel: true,
        value: journalEntry?.back_pain,
      });
    }

    if (journalEntry?.headache) {
      tableRows.push({
        label: 'common.dailyData.headache',
        translateLabel: true,
        value: journalEntry?.headache,
      });
    }

    if (journalEntry?.migraine) {
      tableRows.push({
        label: 'common.dailyData.migraine',
        translateLabel: true,
        value: journalEntry?.migraine,
      });
    }

    if (journalEntry?.body_hair_growth) {
      tableRows.push({
        label: 'common.dailyData.bodyHairGrowth',
        translateLabel: true,
        value: journalEntry?.body_hair_growth,
      });
    }

    if (journalEntry?.acne) {
      tableRows.push({
        label: 'common.dailyData.acne',
        translateLabel: true,
        value: journalEntry?.acne,
      });
    }

    if (journalEntry?.painful_urination) {
      tableRows.push({
        label: 'common.dailyData.painfulUrination',
        translateLabel: true,
        value: journalEntry?.painful_urination,
      });
    }

    if (journalEntry?.urination_frequency) {
      tableRows.push({
        label: 'common.dailyData.urinationFrequency',
        translateLabel: true,
        value: journalEntry?.urination_frequency,
      });
    }

    if (journalEntry?.incontinence) {
      tableRows.push({
        label: 'common.dailyData.incontinence',
        translateLabel: true,
        value: journalEntry?.incontinence,
      });
    }

    if (journalEntry?.sexual_activity) {
      tableRows.push({
        label: 'common.dailyData.sexualActivity',
        translateLabel: true,
        value: journalEntry?.sexual_activity,
      });
    }

    if (journalEntry?.sex_drive) {
      tableRows.push({
        label: 'common.dailyData.sexDrive',
        translateLabel: true,
        value: journalEntry?.sex_drive,
      });
    }

    if (journalEntry?.exercise_intensity) {
      tableRows.push({
        label: 'common.dailyData.exerciseIntesity',
        translateLabel: true,
        value: journalEntry?.exercise_intensity,
      });
    }

    if (journalEntry?.exercise_perceived_effort) {
      tableRows.push({
        label: 'common.dailyData.exercisePerceivedEffort',
        translateLabel: true,
        value: journalEntry?.exercise_perceived_effort,
      });
    }

    if (journalEntry?.hours_of_sleep) {
      tableRows.push({
        label: 'common.dailyData.hoursOfSleep',
        translateLabel: true,
        value: journalEntry?.hours_of_sleep,
        sourceProvider: journalEntry?.autofill_sources?.hours_of_sleep,
      });
    }

    if (journalEntry?.sleep_quality) {
      tableRows.push({
        label: 'common.dailyData.sleepQuality',
        translateLabel: true,
        value: journalEntry?.sleep_quality,
      });
    }

    if (journalEntry?.dream_type) {
      tableRows.push({
        label: 'common.dailyData.dreamType',
        translateLabel: true,
        value: journalEntry?.dream_type,
      });
    }

    if (journalEntry?.overall_mood) {
      tableRows.push({
        label: 'common.dailyData.overallMood',
        translateLabel: true,
        value: journalEntry?.overall_mood,
      });
    }

    if (journalEntry?.anxiety) {
      tableRows.push({
        label: 'common.dailyData.anxiety',
        translateLabel: true,
        value: journalEntry?.anxiety,
      });
    }

    if (journalEntry?.motivation_level) {
      tableRows.push({
        label: 'common.dailyData.motivationLevel',
        translateLabel: true,
        value: journalEntry?.motivation_level,
      });
    }

    if (journalEntry?.productivity_level) {
      tableRows.push({
        label: 'common.dailyData.productivityLevel',
        translateLabel: true,
        value: journalEntry?.productivity_level,
      });
    }

    if (journalEntry?.focus) {
      tableRows.push({
        label: 'common.dailyData.focus',
        translateLabel: true,
        value: journalEntry?.focus,
      });
    }

    if (journalEntry?.brain_fog) {
      tableRows.push({
        label: 'common.dailyData.brainFog',
        translateLabel: true,
        value: journalEntry?.brain_fog,
      });
    }

    if (journalEntry?.memory_problems) {
      tableRows.push({
        label: 'common.dailyData.memoryProblems',
        translateLabel: true,
        value: journalEntry?.memory_problems,
      });
    }

    if (journalEntry?.energy_level) {
      tableRows.push({
        label: 'common.dailyData.energyLevel',
        translateLabel: true,
        value: journalEntry?.energy_level,
      });
    }

    if (journalEntry?.emotional_stability) {
      tableRows.push({
        label: 'common.dailyData.emotionalStability',
        translateLabel: true,
        value: journalEntry?.emotional_stability,
      });
    }

    if (journalEntry?.stress) {
      tableRows.push({
        label: 'common.dailyData.stress',
        translateLabel: true,
        value: journalEntry?.stress,
      });
    }

    if (journalEntry?.mental) {
      tableRows.push({
        label: 'common.dailyData.mental',
        translateLabel: true,
        value: journalEntry?.mental,
      });
    }

    if (journalEntry?.birth_control_pill) {
      tableRows.push({
        label: 'common.dailyData.birthControl',
        translateLabel: true,
        value: journalEntry?.birth_control_pill,
      });
    }

    if (journalEntry?.medication) {
      tableRows.push({
        label: 'common.dailyData.medication',
        translateLabel: true,
        value: journalEntry?.medication,
      });
    }

    if (journalEntry?.ailment) {
      tableRows.push({
        label: 'common.dailyData.ailment',
        translateLabel: true,
        value: journalEntry?.ailment,
      });
    }

    if (journalEntry?.drinking) {
      tableRows.push({
        label: 'common.dailyData.drinking',
        translateLabel: true,
        value: journalEntry?.drinking,
      });
    }

    if (journalEntry?.cannabis) {
      tableRows.push({
        label: 'common.dailyData.cannabis',
        translateLabel: true,
        value: journalEntry?.cannabis,
      });
    }

    if (journalEntry?.hangover) {
      tableRows.push({
        label: 'common.dailyData.hangover',
        translateLabel: true,
        value: journalEntry?.hangover,
      });
    }

    if (journalEntry?.cervical_fluid) {
      tableRows.push({
        label: 'common.dailyData.cervicalFluid',
        translateLabel: true,
        value: journalEntry?.cervical_fluid,
      });
    }

    if (journalEntry?.cervical_position) {
      tableRows.push({
        label: 'common.dailyData.cervicalPosition',
        translateLabel: true,
        value: journalEntry?.cervical_position,
      });
    }

    if (journalEntry?.pain) {
      tableRows.push({
        label: 'common.dailyData.pain',
        translateLabel: true,
        value: journalEntry?.pain,
      });
    }

    if (journalEntry?.cravings) {
      tableRows.push({
        label: 'common.dailyData.cravings',
        translateLabel: true,
        value: journalEntry?.cravings,
      });
    }

    if (journalEntry?.digestion) {
      tableRows.push({
        label: 'common.dailyData.digestion',
        translateLabel: true,
        value: journalEntry?.digestion,
      });
    }

    if (journalEntry?.bloating) {
      tableRows.push({
        label: 'common.dailyData.bloating',
        translateLabel: true,
        value: journalEntry?.bloating,
      });
    }

    if (journalEntry?.head_hair) {
      tableRows.push({
        label: 'common.dailyData.headHair',
        translateLabel: true,
        value: journalEntry?.head_hair,
      });
    }

    if (journalEntry?.skin) {
      tableRows.push({
        label: 'common.dailyData.skin',
        translateLabel: true,
        value: journalEntry?.skin,
      });
    }

    if (journalEntry?.stool) {
      tableRows.push({
        label: 'common.dailyData.stool',
        translateLabel: true,
        value: journalEntry?.stool,
      });
    }

    if (journalEntry?.temperature) {
      tableRows.push({
        label: 'common.dailyData.temperature',
        translateLabel: true,
        value: journalEntry?.temperature,
      });
    }

    if (journalEntry?.injection) {
      tableRows.push({
        label: 'common.dailyData.injection',
        translateLabel: true,
        value: journalEntry?.injection,
      });
    }

    if (journalEntry?.heart_palpitations_or_racing_heart) {
      tableRows.push({
        label: 'common.dailyData.heartPalpitationsOrRacingHeart',
        translateLabel: true,
        value: journalEntry?.heart_palpitations_or_racing_heart,
      });
    }

    if (journalEntry?.weight_gain) {
      tableRows.push({
        label: 'common.dailyData.weightGain',
        translateLabel: true,
        value: journalEntry?.weight_gain,
        prettifiedValue: `${journalEntry?.weight_gain} ${i18n.t(
          'common.measurements.lbs'
        )}`,
      });
    }

    if (journalEntry?.night_sweats) {
      tableRows.push({
        label: 'common.dailyData.nightSweats',
        translateLabel: true,
        value: journalEntry?.night_sweats,
      });
    }

    if (journalEntry?.hair_loss_or_thinning) {
      tableRows.push({
        label: 'common.dailyData.hairLossOrThinning',
        translateLabel: true,
        value: journalEntry?.hair_loss_or_thinning,
      });
    }

    if (journalEntry?.skin_dryness_and_itching) {
      tableRows.push({
        label: 'common.dailyData.skinDrynessAndItching',
        translateLabel: true,
        value: journalEntry?.skin_dryness_and_itching,
      });
    }

    if (journalEntry?.face_sagging_and_wrinkles) {
      tableRows.push({
        label: 'common.dailyData.faceSaggingAndWrinkles',
        translateLabel: true,
        value: journalEntry?.face_sagging_and_wrinkles,
      });
    }

    if (journalEntry?.vaginal_dryness) {
      tableRows.push({
        label: 'common.dailyData.vaginalDryness',
        translateLabel: true,
        value: journalEntry?.vaginal_dryness,
      });
    }

    if (journalEntry?.uti_symptoms) {
      tableRows.push({
        label: 'common.dailyData.utiSymptoms',
        translateLabel: true,
        value: journalEntry?.uti_symptoms,
      });
    }

    if (spikeInfo?.resting_hr) {
      tableRows.push({
        label: 'common.dailyData.spikeInfo.restingHr',
        translateLabel: true,
        value: spikeInfo?.resting_hr,
        prettifiedValue: `${spikeInfo?.resting_hr} ${Constants.HEART_RATE_UNIT}`,
      });
    }

    if (spikeInfo?.avg_hr) {
      tableRows.push({
        label: 'common.dailyData.spikeInfo.avgHr',
        translateLabel: true,
        value: spikeInfo?.avg_hr,
        prettifiedValue: `${spikeInfo?.avg_hr} ${Constants.HEART_RATE_UNIT}`,
      });
    }

    if (spikeInfo?.floors) {
      tableRows.push({
        label: 'common.dailyData.spikeInfo.floors',
        translateLabel: true,
        value: spikeInfo?.floors,
      });
    }

    if (spikeInfo?.steps) {
      tableRows.push({
        label: 'common.dailyData.spikeInfo.steps',
        translateLabel: true,
        value: spikeInfo?.steps,
      });
    }

    if (spikeInfo?.calories_total) {
      tableRows.push({
        label: 'common.dailyData.spikeInfo.caloriesTotal',
        translateLabel: true,
        value: spikeInfo?.calories_total,
        prettifiedValue: `${spikeInfo?.calories_total} ${Constants.CALORIES_UNIT}`,
      });
    }

    return tableRows;
  }

  static getOverviewGroups(journalEntry?: JournalEntry): OverviewGroup[] {
    return [
      {
        title: 'common.dailyData.symptomDetail',
        rows: [
          {
            label: 'common.dailyData.isEverythingFine',
            value: journalEntry?.is_everything_fine,
            prettifiedValue: this.getPrettifiedBooleanValue(
              journalEntry?.is_everything_fine
            ),
            translateLabel: true,
          },
        ],
      },
      {
        title: 'common.dailyData.body',
        rows: [
          {
            label: 'common.dailyData.bleeding',
            translateLabel: true,
            value: journalEntry?.bleeding,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.periodFlowValues.none'),
                  value: 'None',
                },
                {
                  label: i18n.t('common.dailyData.periodFlowValues.spotting'),
                  value: 'Spotting',
                },
                {
                  label: i18n.t('common.dailyData.periodFlowValues.light'),
                  value: 'Light',
                },
                {
                  label: i18n.t('common.dailyData.periodFlowValues.medium'),
                  value: 'Medium',
                },
                {
                  label: i18n.t('common.dailyData.periodFlowValues.heavy'),
                  value: 'Heavy',
                },
              ],
              propertyName: JournalEntryFields.bleeding,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.cervicalFluid',
            translateLabel: true,
            value: journalEntry?.cervical_fluid,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.values.none'),
                  value: 'None',
                },
                {
                  label: i18n.t(
                    'common.dailyData.cervicalFluidValues.eggWhite'
                  ),
                  value: 'Egg-White',
                },
                {
                  label: i18n.t('common.dailyData.cervicalFluidValues.sticky'),
                  value: 'Sticky',
                },
                {
                  label: i18n.t('common.dailyData.cervicalFluidValues.creamy'),
                  value: 'Creamy',
                },
                {
                  label: i18n.t(
                    'common.dailyData.cervicalFluidValues.atypical'
                  ),
                  value: 'Atypical',
                },
              ],
              propertyName: JournalEntryFields.cervical_fluid,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.cervicalPosition',
            translateLabel: true,
            value: journalEntry?.cervical_position,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.cervicalPositionValues.low'),
                  value: 'Low',
                },
                {
                  label: i18n.t('common.dailyData.cervicalPositionValues.high'),
                  value: 'High',
                },
                {
                  label: i18n.t(
                    'common.dailyData.cervicalPositionValues.didNotCheck'
                  ),
                  value: "I didn't check",
                },
              ],
              propertyName: JournalEntryFields.cervical_position,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.hotFlashes',
            translateLabel: true,
            value: journalEntry?.hot_flashes,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.none'),
                  value: 'None',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.mild'),
                  value: 'Mild',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.moderate'
                  ),
                  value: 'Moderate',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.severe'),
                  value: 'Severe',
                },
              ],
              propertyName: JournalEntryFields.hot_flashes,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.temperature',
            translateLabel: true,
            prettifiedValue: journalEntry?.temperature
              ? `${journalEntry?.temperature} °F`
              : '',
            value: journalEntry?.temperature,
            editOptions: {
              propertyName: JournalEntryFields.temperature,
              widgetType: TableRowEditWidgetType.NUMBER,
              min: 95.0,
              max: 105.9,
              step: 0.1,
            },
          },
          {
            label: 'common.dailyData.breastTenderness',
            translateLabel: true,
            value: journalEntry?.breast_tenderness,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.none'),
                  value: 'None',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.mild'),
                  value: 'Mild',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.moderate'
                  ),
                  value: 'Moderate',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.severe'),
                  value: 'Severe',
                },
              ],
              propertyName: JournalEntryFields.breast_tenderness,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.nausea',
            translateLabel: true,
            value: journalEntry?.nausea,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.none'),
                  value: 'None',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.mild'),
                  value: 'Mild',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.moderate'
                  ),
                  value: 'Moderate',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.severe'),
                  value: 'Severe',
                },
              ],
              propertyName: JournalEntryFields.nausea,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.cramps',
            translateLabel: true,
            value: journalEntry?.cramps,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.none'),
                  value: 'None',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.mild'),
                  value: 'Mild',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.moderate'
                  ),
                  value: 'Moderate',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.severe'),
                  value: 'Severe',
                },
              ],
              propertyName: JournalEntryFields.cramps,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.jointPain',
            translateLabel: true,
            value: journalEntry?.joint_pain,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.none'),
                  value: 'None',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.mild'),
                  value: 'Mild',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.moderate'
                  ),
                  value: 'Moderate',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.severe'),
                  value: 'Severe',
                },
              ],
              propertyName: JournalEntryFields.joint_pain,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.backPain',
            translateLabel: true,
            value: journalEntry?.back_pain,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.none'),
                  value: 'None',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.mild'),
                  value: 'Mild',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.moderate'
                  ),
                  value: 'Moderate',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.severe'),
                  value: 'Severe',
                },
              ],
              propertyName: JournalEntryFields.back_pain,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.headache',
            translateLabel: true,
            value: journalEntry?.headache,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.none'),
                  value: 'None',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.mild'),
                  value: 'Mild',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.moderate'
                  ),
                  value: 'Moderate',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.severe'),
                  value: 'Severe',
                },
              ],
              propertyName: JournalEntryFields.headache,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.migraine',
            translateLabel: true,
            value: journalEntry?.migraine,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.none'),
                  value: 'None',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.mild'),
                  value: 'Mild',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.moderate'
                  ),
                  value: 'Moderate',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.severe'),
                  value: 'Severe',
                },
              ],
              propertyName: JournalEntryFields.migraine,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.heartPalpitationsOrRacingHeart',
            translateLabel: true,
            value: journalEntry?.heart_palpitations_or_racing_heart,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.none'),
                  value: 'None',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.mild'),
                  value: 'Mild',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.moderate'
                  ),
                  value: 'Moderate',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.severe'),
                  value: 'Severe',
                },
              ],
              propertyName:
                JournalEntryFields.heart_palpitations_or_racing_heart,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.weightGain',
            translateLabel: true,
            value: journalEntry?.weight_gain,
            editOptions: {
              propertyName: JournalEntryFields.weight_gain,
              widgetType: TableRowEditWidgetType.NUMBER,
              step: 0.1,
              min: 60,
              max: 600,
            },
            prettifiedValue: `${journalEntry?.weight_gain} ${i18n.t(
              'common.measurements.lbs'
            )}`,
          },
          {
            label: 'common.dailyData.dizziness',
            translateLabel: true,
            value: journalEntry?.dizziness,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.none'),
                  value: 'None',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.mild'),
                  value: 'Mild',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.moderate'
                  ),
                  value: 'Moderate',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.severe'),
                  value: 'Severe',
                },
              ],
              propertyName: JournalEntryFields.dizziness,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
        ],
      },
      {
        title: 'common.dailyData.skinAndHair',
        rows: [
          {
            label: 'common.dailyData.hairLossOrThinning',
            translateLabel: true,
            value: journalEntry?.hair_loss_or_thinning,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.headHairValues.noChanges'),
                  value: 'No change',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.mild'),
                  value: 'Mild',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.moderate'
                  ),
                  value: 'Moderate',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.severe'),
                  value: 'Severe',
                },
              ],
              propertyName: JournalEntryFields.hair_loss_or_thinning,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.bodyHairGrowth',
            translateLabel: true,
            value: journalEntry?.body_hair_growth,
            editOptions: {
              options: [
                {
                  label: i18n.t(
                    'common.dailyData.bodyHairGrowthValues.decrease'
                  ),
                  value: 'Decrease',
                },
                {
                  label: i18n.t(
                    'common.dailyData.bodyHairGrowthValues.noChange'
                  ),
                  value: 'No change',
                },
                {
                  label: i18n.t(
                    'common.dailyData.bodyHairGrowthValues.mildIncrease'
                  ),
                  value: 'Mild increase, fine hair',
                },
                {
                  label: i18n.t(
                    'common.dailyData.bodyHairGrowthValues.noticeableIncrease'
                  ),
                  value: 'Noticeable increase, coarse, darker hair',
                },
              ],
              propertyName: JournalEntryFields.body_hair_growth,
              widgetType: TableRowEditWidgetType.MULTI_SELECT,
            },
          },
          {
            label: 'common.dailyData.acne',
            translateLabel: true,
            value: journalEntry?.acne,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.none'),
                  value: 'None',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.mild'),
                  value: 'Mild',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.moderate'
                  ),
                  value: 'Moderate',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.severe'),
                  value: 'Severe',
                },
                {
                  label: i18n.t('common.dailyData.acneValues.cystic'),
                  value: 'Cystic',
                },
              ],
              propertyName: JournalEntryFields.acne,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.skinDrynessAndItching',
            translateLabel: true,
            value: journalEntry?.skin_dryness_and_itching,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.none'),
                  value: 'None',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.mild'),
                  value: 'Mild',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.moderate'
                  ),
                  value: 'Moderate',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.severe'),
                  value: 'Severe',
                },
              ],
              propertyName: JournalEntryFields.skin_dryness_and_itching,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.faceSaggingAndWrinkles',
            translateLabel: true,
            value: journalEntry?.face_sagging_and_wrinkles,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.none'),
                  value: 'None',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.mild'),
                  value: 'Mild',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.moderate'
                  ),
                  value: 'Moderate',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.severe'),
                  value: 'Severe',
                },
              ],
              propertyName: JournalEntryFields.face_sagging_and_wrinkles,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
        ],
      },
      {
        title: 'common.dailyData.dietAndDigestion',
        rows: [
          {
            label: 'common.dailyData.stool',
            translateLabel: true,
            value: journalEntry?.stool,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.stoolValues.normal'),
                  value: 'Normal',
                },
                {
                  label: i18n.t('common.dailyData.stoolValues.soft'),
                  value: 'Soft',
                },
                {
                  label: i18n.t('common.dailyData.stoolValues.watery'),
                  value: 'Watery',
                },
                {
                  label: i18n.t('common.dailyData.stoolValues.firm'),
                  value: 'Firm',
                },
                {
                  label: i18n.t('common.dailyData.stoolValues.rockHard'),
                  value: 'Rock hard',
                },
              ],
              propertyName: JournalEntryFields.stool,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.cravings',
            translateLabel: true,
            value: journalEntry?.cravings,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.cravingValues.none'),
                  value: 'None',
                },
                {
                  label: i18n.t('common.dailyData.cravingValues.sweet'),
                  value: 'Sweet',
                },
                {
                  label: i18n.t('common.dailyData.cravingValues.carbohydrates'),
                  value: 'Carbs',
                },
                {
                  label: i18n.t('common.dailyData.cravingValues.salty'),
                  value: 'Salty',
                },
                {
                  label: i18n.t('common.dailyData.cravingValues.greasyFood'),
                  value: 'Greasy Food',
                },
                {
                  label: i18n.t('common.dailyData.cravingValues.sour'),
                  value: 'Sour',
                },
                {
                  label: i18n.t('common.dailyData.cravingValues.spicy'),
                  value: 'Spicy',
                },
              ],
              propertyName: JournalEntryFields.cravings,
              widgetType: TableRowEditWidgetType.MULTI_SELECT,
            },
          },
          {
            label: 'common.dailyData.digestion',
            translateLabel: true,
            value: journalEntry?.digestion,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.digestionValues.normal'),
                  value: 'Normal',
                },
                {
                  label: i18n.t('common.dailyData.digestionValues.vomiting'),
                  value: 'Vomiting',
                },
                {
                  label: i18n.t('common.dailyData.digestionValues.nausea'),
                  value: 'Nausea',
                },
                {
                  label: i18n.t(
                    'common.dailyData.digestionValues.bloatingOrGas'
                  ),
                  value: 'Bloating/Gas',
                },
                {
                  label: i18n.t('common.dailyData.digestionValues.heartburn'),
                  value: 'Heartburn',
                },
              ],
              propertyName: JournalEntryFields.digestion,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.bloating',
            translateLabel: true,
            value: journalEntry?.bloating,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.none'),
                  value: 'None',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.mild'),
                  value: 'Mild',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.moderate'
                  ),
                  value: 'Moderate',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.severe'),
                  value: 'Severe',
                },
              ],
              propertyName: JournalEntryFields.bloating,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
        ],
      },
      {
        title: 'common.dailyData.urination',
        rows: [
          {
            label: 'common.dailyData.painfulUrination',
            translateLabel: true,
            value: journalEntry?.painful_urination,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.none'),
                  value: 'None',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.mild'),
                  value: 'Mild',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.moderate'
                  ),
                  value: 'Moderate',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.severe'),
                  value: 'Severe',
                },
              ],
              propertyName: JournalEntryFields.painful_urination,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.urinationFrequency',
            translateLabel: true,
            value: journalEntry?.urination_frequency,
            editOptions: {
              options: [
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.veryNegative'
                  ),
                  value: 'Very negative',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.negative'
                  ),
                  value: 'Negative',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.neutral'),
                  value: 'Neutral',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.positive'
                  ),
                  value: 'Positive',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.veryPositive'
                  ),
                  value: 'Very positive',
                },
              ],
              propertyName: JournalEntryFields.urination_frequency,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.incontinence',
            translateLabel: true,
            value: journalEntry?.incontinence,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.none'),
                  value: 'None',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.mild'),
                  value: 'Mild',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.moderate'
                  ),
                  value: 'Moderate',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.severe'),
                  value: 'Severe',
                },
              ],
              propertyName: JournalEntryFields.incontinence,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.vaginalDryness',
            translateLabel: true,
            value: journalEntry?.vaginal_dryness,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.none'),
                  value: 'None',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.mild'),
                  value: 'Mild',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.moderate'
                  ),
                  value: 'Moderate',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.severe'),
                  value: 'Severe',
                },
              ],
              propertyName: JournalEntryFields.vaginal_dryness,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.utiSymptoms',
            translateLabel: true,
            value: journalEntry?.uti_symptoms,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.none'),
                  value: 'None',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.mild'),
                  value: 'Mild',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.moderate'
                  ),
                  value: 'Moderate',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.severe'),
                  value: 'Severe',
                },
              ],
              propertyName: JournalEntryFields.uti_symptoms,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
        ],
      },
      {
        title: 'common.dailyData.sex',
        rows: [
          {
            label: 'common.dailyData.sexualActivity',
            translateLabel: true,
            value: journalEntry?.sexual_activity,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.sexValues.none'),
                  value: 'None',
                },
                {
                  label: i18n.t('common.dailyData.sexValues.unprotected'),
                  value: 'Unprotected',
                },
                {
                  label: i18n.t('common.dailyData.sexValues.protected'),
                  value: 'Protected',
                },
                {
                  label: i18n.t('common.dailyData.sexValues.withdrawal'),
                  value: 'Withdrawal',
                },
              ],
              propertyName: JournalEntryFields.sexual_activity,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.painfulSex',
            translateLabel: true,
            value: journalEntry?.painful_sex,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.none'),
                  value: 'None',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.mild'),
                  value: 'Mild',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.moderate'
                  ),
                  value: 'Moderate',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.severe'),
                  value: 'Severe',
                },
              ],
              propertyName: JournalEntryFields.painful_sex,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.sexDrive',
            translateLabel: true,
            value: journalEntry?.sex_drive,
            editOptions: {
              options: [
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.veryNegative'
                  ),
                  value: 'Very negative',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.negative'
                  ),
                  value: 'Negative',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.neutral'),
                  value: 'Neutral',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.positive'
                  ),
                  value: 'Positive',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.veryPositive'
                  ),
                  value: 'Very positive',
                },
              ],
              propertyName: JournalEntryFields.sex_drive,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
        ],
      },
      {
        title: 'common.dailyData.exercise',
        rows: [
          {
            label: 'common.dailyData.exerciseIntesity',
            translateLabel: true,
            value: journalEntry?.exercise_intensity,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.exerciseValues.none'),
                  value: 'None',
                },
                {
                  label: i18n.t('common.dailyData.exerciseValues.lowImpact'),
                  value: 'Low-Impact',
                },
                {
                  label: i18n.t(
                    'common.dailyData.exerciseValues.moderateImpact'
                  ),
                  value: 'Moderate-Impact',
                },
                {
                  label: i18n.t('common.dailyData.exerciseValues.highImpact'),
                  value: 'High-Impact',
                },
              ],
              propertyName: JournalEntryFields.exercise_intensity,
              widgetType: TableRowEditWidgetType.MULTI_SELECT,
            },
          },
          {
            label: 'common.dailyData.exercisePerceivedEffort',
            translateLabel: true,
            value: journalEntry?.exercise_perceived_effort,
            editOptions: {
              options: [
                {
                  label: i18n.t(
                    'common.dailyData.exercisePerceivedEffortValues.easierThanNormal'
                  ),
                  value: 'Easier than normal',
                },
                {
                  label: i18n.t(
                    'common.dailyData.exercisePerceivedEffortValues.normal'
                  ),
                  value: 'normal',
                },
                {
                  label: i18n.t(
                    'common.dailyData.exercisePerceivedEffortValues.harderThanNormal'
                  ),
                  value: 'Harder than normal',
                },
              ],
              propertyName: JournalEntryFields.exercise_perceived_effort,
              widgetType: TableRowEditWidgetType.MULTI_SELECT,
            },
          },
        ],
      },
      {
        title: 'common.dailyData.sleep',
        rows: [
          {
            label: 'common.dailyData.hoursOfSleep',
            translateLabel: true,
            value: journalEntry?.hours_of_sleep,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.sleepValues.zeroMore'),
                  value: '0-3 hrs',
                },
                {
                  label: i18n.t('common.dailyData.sleepValues.threeMore'),
                  value: '3-6 hrs',
                },
                {
                  label: i18n.t('common.dailyData.sleepValues.sixMore'),
                  value: '6-9 hrs',
                },
                {
                  label: i18n.t('common.dailyData.sleepValues.nineMore'),
                  value: '9+ hrs',
                },
              ],
              propertyName: JournalEntryFields.hours_of_sleep,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.sleepQuality',
            translateLabel: true,
            value: journalEntry?.sleep_quality,
            editOptions: {
              options: [
                {
                  label: i18n.t(
                    'common.dailyData.sleepQualityValues.troubleFallingAsleep'
                  ),
                  value: 'Trouble falling asleep',
                },
                {
                  label: i18n.t(
                    'common.dailyData.sleepQualityValues.troubleStayingAsleep'
                  ),
                  value: 'Trouble staying asleep',
                },
                {
                  label: i18n.t('common.dailyData.sleepQualityValues.restless'),
                  value: 'Restless',
                },
                {
                  label: i18n.t(
                    'common.dailyData.sleepQualityValues.goodQuality'
                  ),
                  value: 'Good quality',
                },
              ],
              propertyName: JournalEntryFields.sleep_quality,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.dreamType',
            translateLabel: true,
            value: journalEntry?.dream_type,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.dreamsValues.noDreams'),
                  value: 'No Dreams',
                },
                {
                  label: i18n.t('common.dailyData.dreamsValues.dark'),
                  value: 'Dark',
                },
                {
                  label: i18n.t('common.dailyData.dreamsValues.disturbing'),
                  value: 'Disturbing',
                },
                {
                  label: i18n.t('common.dailyData.dreamsValues.stressful'),
                  value: 'Stressful',
                },
                {
                  label: i18n.t('common.dailyData.dreamsValues.vivid'),
                  value: 'Vivid',
                },
                {
                  label: i18n.t('common.dailyData.dreamsValues.soothing'),
                  value: 'Soothing',
                },
                {
                  label: i18n.t('common.dailyData.dreamsValues.happy'),
                  value: 'Happy',
                },
              ],
              propertyName: JournalEntryFields.dream_type,
              widgetType: TableRowEditWidgetType.MULTI_SELECT,
            },
          },
          {
            label: 'common.dailyData.nightSweats',
            translateLabel: true,
            value: journalEntry?.night_sweats,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.none'),
                  value: 'None',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.mild'),
                  value: 'Mild',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.moderate'
                  ),
                  value: 'Moderate',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.severe'),
                  value: 'Severe',
                },
              ],
              propertyName: JournalEntryFields.night_sweats,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
        ],
      },
      {
        title: 'common.dailyData.mentalWellbeing',
        rows: [
          {
            label: 'common.dailyData.overallMood',
            translateLabel: true,
            value: journalEntry?.overall_mood,
            editOptions: {
              options: [
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.veryNegative'
                  ),
                  value: 'Very negative',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.negative'
                  ),
                  value: 'Negative',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.neutral'),
                  value: 'Neutral',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.positive'
                  ),
                  value: 'Positive',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.veryPositive'
                  ),
                  value: 'Very positive',
                },
              ],
              propertyName: JournalEntryFields.overall_mood,
              widgetType: TableRowEditWidgetType.MULTI_SELECT,
            },
          },
          {
            label: 'common.dailyData.anxiety',
            translateLabel: true,
            value: journalEntry?.anxiety,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.none'),
                  value: 'None',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.mild'),
                  value: 'Mild',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.moderate'
                  ),
                  value: 'Moderate',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.severe'),
                  value: 'Severe',
                },
              ],
              propertyName: JournalEntryFields.anxiety,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.motivationLevel',
            translateLabel: true,
            value: journalEntry?.motivation_level,
            editOptions: {
              options: [
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.veryNegative'
                  ),
                  value: 'Very negative',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.negative'
                  ),
                  value: 'Negative',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.normal'),
                  value: 'Normal',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.positive'
                  ),
                  value: 'Positive',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.veryPositive'
                  ),
                  value: 'Very positive',
                },
              ],
              propertyName: JournalEntryFields.motivation_level,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.productivityLevel',
            translateLabel: true,
            value: journalEntry?.productivity_level,
            editOptions: {
              options: [
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.veryNegative'
                  ),
                  value: 'Very negative',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.negative'
                  ),
                  value: 'Negative',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.normal'),
                  value: 'Normal',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.positive'
                  ),
                  value: 'Positive',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.veryPositive'
                  ),
                  value: 'Very positive',
                },
              ],
              propertyName: JournalEntryFields.productivity_level,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.focus',
            translateLabel: true,
            value: journalEntry?.focus,
            editOptions: {
              options: [
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.veryNegative'
                  ),
                  value: 'Very negative',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.negative'
                  ),
                  value: 'Negative',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.normal'),
                  value: 'Normal',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.positive'
                  ),
                  value: 'Positive',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.veryPositive'
                  ),
                  value: 'Very positive',
                },
              ],
              propertyName: JournalEntryFields.focus,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.brainFog',
            translateLabel: true,
            value: journalEntry?.brain_fog,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.none'),
                  value: 'None',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.mild'),
                  value: 'Mild',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.moderate'
                  ),
                  value: 'Moderate',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.severe'),
                  value: 'Severe',
                },
              ],
              propertyName: JournalEntryFields.brain_fog,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.memoryProblems',
            translateLabel: true,
            value: journalEntry?.memory_problems,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.none'),
                  value: 'None',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.mild'),
                  value: 'Mild',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.moderate'
                  ),
                  value: 'Moderate',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.severe'),
                  value: 'Severe',
                },
              ],
              propertyName: JournalEntryFields.memory_problems,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.energyLevel',
            translateLabel: true,
            value: journalEntry?.energy_level,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.energyValues.exhausted'),
                  value: 'Exhausted',
                },
                {
                  label: i18n.t('common.dailyData.energyValues.lowEnergy'),
                  value: 'Low',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.normal'),
                  value: 'Normal',
                },
                {
                  label: i18n.t('common.dailyData.energyValues.highEnergy'),
                  value: 'High',
                },
              ],
              propertyName: JournalEntryFields.energy_level,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.emotionalStability',
            translateLabel: true,
            value: journalEntry?.emotional_stability,
            editOptions: {
              options: [
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.veryNegative'
                  ),
                  value: 'Very negative',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.negative'
                  ),
                  value: 'Negative',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.normal'),
                  value: 'Normal',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.positive'
                  ),
                  value: 'Positive',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.veryPositive'
                  ),
                  value: 'Very positive',
                },
              ],
              propertyName: JournalEntryFields.emotional_stability,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.stress',
            translateLabel: true,
            value: journalEntry?.stress,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.none'),
                  value: 'None',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.mild'),
                  value: 'Mild',
                },
                {
                  label: i18n.t(
                    'common.dailyData.commonSymptomValues.moderate'
                  ),
                  value: 'Moderate',
                },
                {
                  label: i18n.t('common.dailyData.commonSymptomValues.severe'),
                  value: 'Severe',
                },
              ],
              propertyName: JournalEntryFields.stress,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
        ],
      },
      {
        title: 'common.dailyData.medical',
        rows: [
          {
            label: 'common.dailyData.birthControl',
            translateLabel: true,
            value: journalEntry?.birth_control_pill,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.birthControlValues.taken'),
                  value: 'Taken',
                },
                {
                  label: i18n.t('common.dailyData.birthControlValues.late'),
                  value: 'Late',
                },
                {
                  label: i18n.t('common.dailyData.birthControlValues.missed'),
                  value: 'Missed',
                },
                {
                  label: i18n.t('common.dailyData.birthControlValues.double'),
                  value: 'Double',
                },
              ],
              propertyName: JournalEntryFields.birth_control_pill,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.medication',
            translateLabel: true,
            value: journalEntry?.medication,
            editOptions: {
              propertyName: JournalEntryFields.medication,
              widgetType: TableRowEditWidgetType.TEXT_AREA,
            },
          },
          {
            label: 'common.dailyData.injection',
            translateLabel: true,
            value: journalEntry?.injection,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.injectionValues.none'),
                  value: 'None',
                },
                {
                  label: i18n.t(
                    'common.dailyData.injectionValues.administered'
                  ),
                  value: 'Administered',
                },
                {
                  label: i18n.t('common.dailyData.injectionValues.missed'),
                  value: 'Missed',
                },
              ],
              propertyName: JournalEntryFields.injection,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.ailment',
            translateLabel: true,
            value: journalEntry?.ailment,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.ailmentValues.none'),
                  value: 'None',
                },
                {
                  label: i18n.t('common.dailyData.ailmentValues.fever'),
                  value: 'Fever',
                },
                {
                  label: i18n.t('common.dailyData.ailmentValues.covid'),
                  value: 'COVID',
                },
                {
                  label: i18n.t('common.dailyData.ailmentValues.coldOrFlu'),
                  value: 'Cold/Flu',
                },
                {
                  label: i18n.t('common.dailyData.ailmentValues.allergy'),
                  value: 'Allergy',
                },
                {
                  label: i18n.t('common.dailyData.ailmentValues.injury'),
                  value: 'Injury',
                },
              ],
              propertyName: JournalEntryFields.ailment,
              widgetType: TableRowEditWidgetType.MULTI_SELECT,
            },
          },
          {
            label: 'common.dailyData.vitaminsAndSupplements',
            translateLabel: true,
            value: journalEntry?.vitamins_and_supplements,
            editOptions: {
              propertyName: JournalEntryFields.vitamins_and_supplements,
              widgetType: TableRowEditWidgetType.TEXT_AREA,
            },
          },
        ],
      },
      {
        title: 'common.dailyData.social',
        rows: [
          {
            label: 'common.dailyData.drinking',
            translateLabel: true,
            value: journalEntry?.drinking,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.drinkingValues.zeroDrinks'),
                  value: '0 drinks',
                },
                {
                  label: i18n.t('common.dailyData.drinkingValues.oneDrink'),
                  value: '1 drink',
                },
                {
                  label: i18n.t('common.dailyData.drinkingValues.twoDrinks'),
                  value: '2 drinks',
                },
                {
                  label: i18n.t('common.dailyData.drinkingValues.threeDrinks'),
                  value: '3 drinks',
                },
                {
                  label: i18n.t(
                    'common.dailyData.drinkingValues.fourPlusDrinks'
                  ),
                  value: '4+ drinks',
                },
              ],
              propertyName: JournalEntryFields.drinking,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.cannabis',
            translateLabel: true,
            value: journalEntry?.cannabis,
            editOptions: {
              options: [
                {
                  label: i18n.t('common.dailyData.cannabisValues.no'),
                  value: 'No',
                },
                {
                  label: i18n.t('common.dailyData.cannabisValues.edible'),
                  value: 'Edible',
                },
                {
                  label: i18n.t('common.dailyData.cannabisValues.smoke'),
                  value: 'Smoke',
                },
                {
                  label: i18n.t('common.dailyData.cannabisValues.vape'),
                  value: 'Vape',
                },
              ],
              propertyName: JournalEntryFields.cannabis,
              widgetType: TableRowEditWidgetType.SELECT,
            },
          },
          {
            label: 'common.dailyData.hangover',
            value: journalEntry?.hangover,
            prettifiedValue: this.getPrettifiedBooleanValue(
              journalEntry?.hangover
            ),
            translateLabel: true,
            editOptions: {
              propertyName: JournalEntryFields.hangover,
              widgetType: TableRowEditWidgetType.BOOLEAN,
            },
          },
        ],
      },
      {
        title: 'common.dailyData.notes',
        rows: [
          {
            label: 'common.dailyData.notes',
            translateLabel: true,
            value: journalEntry?.notes,
          },
        ],
      },
      {
        title: 'common.dailyData.meta',
        rows: [
          {
            label: 'common.os',
            translateLabel: true,
            value: journalEntry?.meta?.os,
          },
          {
            label: 'common.osVersion',
            translateLabel: true,
            value: journalEntry?.meta?.os_version,
          },
          {
            label: 'common.appVersion',
            translateLabel: true,
            value: journalEntry?.meta?.app_version,
          },
          {
            label: 'common.deviceModel',
            translateLabel: true,
            value: journalEntry?.meta?.device_model,
          },
          {
            label: 'common.timeZoneAbbr',
            translateLabel: true,
            value: journalEntry?.meta?.time_zone_abbreviation,
          },
          {
            label: 'common.timeZoneId',
            translateLabel: true,
            value: journalEntry?.meta?.time_zone_identifier,
          },
        ],
      },
    ];
  }

  static getReadonlyOverviewGroups(
    journalEntry?: JournalEntry
  ): OverviewGroup[] {
    return [
      {
        title: 'common.dailyData.symptomDetail',
        rows: [
          {
            label: 'common.dailyData.isEverythingFine',
            value: journalEntry?.is_everything_fine,
            prettifiedValue: this.getPrettifiedBooleanValue(
              journalEntry?.is_everything_fine
            ),
            translateLabel: true,
          },
        ],
      },
      {
        title: 'common.dailyData.body',
        rows: [
          {
            label: 'common.dailyData.period',
            translateLabel: true,
            value: journalEntry?.period_flow,
          },
          {
            label: 'common.dailyData.breakThroughBleeding',
            translateLabel: true,
            value: journalEntry?.breakthrough_bleeding,
          },
          {
            label: 'common.dailyData.cervicalFluid',
            translateLabel: true,
            value: journalEntry?.cervical_fluid,
          },
          {
            label: 'common.dailyData.cervicalPosition',
            translateLabel: true,
            value: journalEntry?.cervical_position,
          },
          {
            label: 'common.dailyData.hotFlashes',
            translateLabel: true,
            value: journalEntry?.hot_flashes,
          },
          {
            label: 'common.dailyData.temperature',
            translateLabel: true,
            prettifiedValue: journalEntry?.temperature
              ? `${journalEntry?.temperature} °F`
              : '',
            value: journalEntry?.temperature,
          },
          {
            label: 'common.dailyData.breastTenderness',
            translateLabel: true,
            value: journalEntry?.breast_tenderness,
          },
          {
            label: 'common.dailyData.nausea',
            translateLabel: true,
            value: journalEntry?.nausea,
          },
          {
            label: 'common.dailyData.cramps',
            translateLabel: true,
            value: journalEntry?.cramps,
          },
          {
            label: 'common.dailyData.jointPain',
            translateLabel: true,
            value: journalEntry?.joint_pain,
          },
          {
            label: 'common.dailyData.backPain',
            translateLabel: true,
            value: journalEntry?.back_pain,
          },
          {
            label: 'common.dailyData.headache',
            translateLabel: true,
            value: journalEntry?.headache,
          },
          {
            label: 'common.dailyData.migraine',
            translateLabel: true,
            value: journalEntry?.migraine,
          },
          {
            label: 'common.dailyData.heartPalpitationsOrRacing',
            translateLabel: true,
            value: journalEntry?.heart_palpitations_or_racing_heart,
          },
          {
            label: 'common.dailyData.dizziness',
            translateLabel: true,
            value: journalEntry?.dizziness,
          },
          {
            label: 'common.dailyData.weightGain',
            translateLabel: true,
            value: journalEntry?.weight_gain,
            prettifiedValue: `${journalEntry?.weight_gain} ${i18n.t(
              'common.measurements.lbs'
            )}`,
          },
        ],
      },
      {
        title: 'common.dailyData.skinAndHair',
        rows: [
          {
            label: 'common.dailyData.hairLossOrThinning',
            translateLabel: true,
            value: journalEntry?.hair_loss_or_thinning,
          },
          {
            label: 'common.dailyData.bodyHairGrowth',
            translateLabel: true,
            value: journalEntry?.body_hair_growth,
          },
          {
            label: 'common.dailyData.acne',
            translateLabel: true,
            value: journalEntry?.acne,
          },
          {
            label: 'common.dailyData.skinDryniessAndItching',
            translateLabel: true,
            value: journalEntry?.skin_dryness_and_itching,
          },
          {
            label: 'common.dailyData.faceSaggingAndWrinkles',
            translateLabel: true,
            value: journalEntry?.face_sagging_and_wrinkles,
          },
        ],
      },
      {
        title: 'common.dailyData.dietAndDigestion',
        rows: [
          {
            label: 'common.dailyData.stool',
            translateLabel: true,
            value: journalEntry?.stool,
          },
          {
            label: 'common.dailyData.cravings',
            translateLabel: true,
            value: journalEntry?.cravings,
          },
          {
            label: 'common.dailyData.digestion',
            translateLabel: true,
            value: journalEntry?.digestion,
          },
          {
            label: 'common.dailyData.bloating',
            translateLabel: true,
            value: journalEntry?.bloating,
          },
        ],
      },
      {
        title: 'common.dailyData.urination',
        rows: [
          {
            label: 'common.dailyData.painfulUrination',
            translateLabel: true,
            value: journalEntry?.painful_urination,
          },
          {
            label: 'common.dailyData.urinationFrequency',
            translateLabel: true,
            value: journalEntry?.urination_frequency,
          },
          {
            label: 'common.dailyData.incontinence',
            translateLabel: true,
            value: journalEntry?.incontinence,
          },
          {
            label: 'common.dailyData.vaginalDryness',
            translateLabel: true,
            value: journalEntry?.vaginal_dryness,
          },
          {
            label: 'common.dailyData.utiSymptoms',
            translateLabel: true,
            value: journalEntry?.uti_symptoms,
          },
        ],
      },
      {
        title: 'common.dailyData.sex',
        rows: [
          {
            label: 'common.dailyData.sexualActivity',
            translateLabel: true,
            value: journalEntry?.sexual_activity,
          },
          {
            label: 'common.dailyData.painfulSex',
            translateLabel: true,
            value: journalEntry?.painful_sex,
          },
          {
            label: 'common.dailyData.sexDrive',
            translateLabel: true,
            value: journalEntry?.sex_drive,
          },
        ],
      },
      {
        title: 'common.dailData.exercise',
        rows: [
          {
            label: 'common.dailyData.exerciseIntesity',
            translateLabel: true,
            value: journalEntry?.exercise_intensity,
          },
          {
            label: 'common.dailyData.exercisePerceivedEffort',
            translateLabel: true,
            value: journalEntry?.exercise_perceived_effort,
          },
        ],
      },
      {
        title: 'common.dailyData.sleep',
        rows: [
          {
            label: 'common.dailyData.hoursOfSleep',
            translateLabel: true,
            value: journalEntry?.hours_of_sleep,
          },
          {
            label: 'common.dailyData.sleepQuality',
            translateLabel: true,
            value: journalEntry?.sleep_quality,
          },
          {
            label: 'common.dailyData.dreamType',
            translateLabel: true,
            value: journalEntry?.dream_type,
          },
        ],
      },
      {
        title: 'common.dailData.mentalWellbeing',
        rows: [
          {
            label: 'common.dailyData.overallMood',
            translateLabel: true,
            value: journalEntry?.overall_mood,
          },
          {
            label: 'common.dailyData.anxiety',
            translateLabel: true,
            value: journalEntry?.anxiety,
          },
          {
            label: 'common.dailyData.motivationLevel',
            translateLabel: true,
            value: journalEntry?.motivation_level,
          },
          {
            label: 'common.dailyData.productivityLevel',
            translateLabel: true,
            value: journalEntry?.productivity_level,
          },
          {
            label: 'common.dailyData.focus',
            translateLabel: true,
            value: journalEntry?.focus,
          },
          {
            label: 'common.dailyData.brainFog',
            translateLabel: true,
            value: journalEntry?.brain_fog,
          },
          {
            label: 'common.dailyData.memoryProblems',
            translateLabel: true,
            value: journalEntry?.memory_problems,
          },
          {
            label: 'common.dailyData.energyLevel',
            translateLabel: true,
            value: journalEntry?.energy_level,
          },
          {
            label: 'common.dailyData.emotionalStability',
            translateLabel: true,
            value: journalEntry?.emotional_stability,
          },
          {
            label: 'common.dailyData.stress',
            translateLabel: true,
            value: journalEntry?.stress,
          },
        ],
      },
      {
        title: 'common.dailyData.medical',
        rows: [
          {
            label: 'common.dailyData.birthControl',
            translateLabel: true,
            value: journalEntry?.birth_control_pill,
          },
          {
            label: 'common.dailyData.medication',
            translateLabel: true,
            value: journalEntry?.medication,
          },
          {
            label: 'common.dailyData.injection',
            translateLabel: true,
            value: journalEntry?.injection,
          },
          {
            label: 'common.dailyData.ailment',
            translateLabel: true,
            value: journalEntry?.ailment,
          },
          {
            label: 'common.dailyData.vitaminsAndSupplements',
            translateLabel: true,
            value: journalEntry?.vitamins_and_supplements,
          },
        ],
      },
      {
        title: 'common.dailyData.social',
        rows: [
          {
            label: 'common.dailyData.drinking',
            translateLabel: true,
            value: journalEntry?.drinking,
          },
          {
            label: 'common.dailyData.cannabis',
            translateLabel: true,
            value: journalEntry?.cannabis,
          },
          {
            label: 'common.dailyData.hangover',
            value: journalEntry?.hangover,
            prettifiedValue: this.getPrettifiedBooleanValue(
              !!journalEntry?.hangover
            ),
            translateLabel: true,
          },
        ],
      },
      {
        title: 'common.dailyData.notes',
        rows: [
          {
            label: 'common.dailyData.notes',
            translateLabel: true,
            value: journalEntry?.notes,
          },
        ],
      },
      {
        title: 'common.dailyData.meta',
        rows: [
          {
            label: 'common.os',
            translateLabel: true,
            value: journalEntry?.meta?.os,
          },
          {
            label: 'common.osVersion',
            translateLabel: true,
            value: journalEntry?.meta?.os_version,
          },
          {
            label: 'common.appVersion',
            translateLabel: true,
            value: journalEntry?.meta?.app_version,
          },
          {
            label: 'common.deviceModel',
            translateLabel: true,
            value: journalEntry?.meta?.device_model,
          },
          {
            label: 'common.timeZoneAbbr',
            translateLabel: true,
            value: journalEntry?.meta?.time_zone_abbreviation,
          },
          {
            label: 'common.timeZoneId',
            translateLabel: true,
            value: journalEntry?.meta?.time_zone_identifier,
          },
        ],
      },
    ];
  }

  static mapSpikeInfoToTable(spikeInfo: SpikeInfo): OvTableData {
    return [
      {
        label: 'common.dailyData.spikeInfo.restingHr',
        translateLabel: true,
        value: spikeInfo?.resting_hr,
        prettifiedValue: spikeInfo?.resting_hr
          ? `${spikeInfo?.resting_hr} ${Constants.HEART_RATE_UNIT}`
          : '-',
      },
      {
        label: 'common.dailyData.spikeInfo.avgHr',
        translateLabel: true,
        value: spikeInfo?.avg_hr,
        prettifiedValue: spikeInfo?.avg_hr
          ? `${spikeInfo?.avg_hr} ${Constants.HEART_RATE_UNIT}`
          : '-',
      },
      {
        label: 'common.dailyData.spikeInfo.floors',
        translateLabel: true,
        value: spikeInfo?.floors,
      },
      {
        label: 'common.dailyData.spikeInfo.steps',
        translateLabel: true,
        value: spikeInfo?.steps,
      },
      {
        label: 'common.dailyData.spikeInfo.caloriesTotal',
        translateLabel: true,
        value: spikeInfo?.calories_total,
        prettifiedValue: spikeInfo?.calories_total
          ? `${spikeInfo?.calories_total} ${Constants.CALORIES_UNIT}`
          : '-',
      },
    ];
  }

  static getPrettifiedBooleanValue(value?: boolean) {
    if (value === null || value === undefined) {
      return '-';
    }

    return value ? i18n.t('common.actions.yes') : i18n.t('common.actions.no');
  }
}
